import { get_appThemeLive3eistjx4ilovl as get_appThemeLive } from './views/theming/appTheme.mjs';
import { root92aurhljvuc2 as root } from '../../../kiteui-library/com/lightningkite/kiteui/root.mjs';
import { PageNavigator20tezdf2xr1uc as PageNavigator } from '../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { appl9jr7k6l38bt as app } from './app.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AutoRoutes3nqqi7p59slz8 as get_AutoRoutes } from './views/autoroutes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function main() {
  var tmp = get_appThemeLive();
  root(tmp, main$lambda);
}
function main$lambda($this$root) {
  var tmp = new (PageNavigator())(main$lambda$lambda);
  app($this$root, tmp, new (PageNavigator())(main$lambda$lambda_0));
  return Unit_instance;
}
function main$lambda$lambda() {
  return get_AutoRoutes();
}
function main$lambda$lambda_0() {
  return get_AutoRoutes();
}
function mainWrapper() {
  main();
}
//region block: exports
export {
  mainWrapper as mainWrapper3j1n6ibqpz7ai,
};
//endregion

//# sourceMappingURL=main.mjs.map
